import * as React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useUserAuth } from '@/state/cookieContext';

/**
 * 유저에게 라우팅 권한이 있는지 체크합니다. 없으면 로그인 페이지로 이동합니다.
 */
export default function UserAuthGuard({ roles, children }: { roles: string[]; children: React.ReactNode }) {
  const userAuth = useUserAuth();
  const location = useLocation();

  const hasRole = roles.some(role => userAuth?.roles.includes(role));

  if (!hasRole) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // 추후 롤보다 작은 단위의 권한을 부여할 때 사용
  // const hasPermission = permissions
  //   ? permissions.some((permission) => user.permissions.includes(permission))
  //   : true;
  //
  // if (!hasPermission) {
  //   return <Navigate to="/login" state={{ from: location }} replace />;
  // }

  // if (!hasRole || !hasPermission) {
  //   return <Navigate to={redirectPath} state={{ from: location }} replace />;
  // }

  return children;
}
